import { createFileRoute } from "@tanstack/react-router";
import SutterHealthPlanInsurance, {
  config,
} from "@/pages/SutterHealthPlanInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/sutter-health-plan-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Sutter Health Plan TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Sutter Health Plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Sutter Health Plan in Coral.",
        },
        {
          property: "og:title",
          content: "Sutter Health Plan TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Sutter Health Plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Sutter Health Plan in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/sutter-health-plan-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/sutter-health-plan-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SutterHealthPlanInsurance />;
}
